var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoretext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5464_4028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05032 4.70308H20.1699C20.4486 4.70308 20.7159 4.59238 20.9129 4.39532C21.11 4.19827 21.2207 3.931 21.2207 3.65232C21.2207 3.37364 21.11 3.10638 20.9129 2.90932C20.7159 2.71227 20.4486 2.60156 20.1699 2.60156H1.05032C0.771639 2.60156 0.504375 2.71227 0.30732 2.90932C0.110264 3.10638 -0.000442505 3.37364 -0.000442505 3.65232C-0.000442505 3.931 0.110264 4.19827 0.30732 4.39532C0.504375 4.59238 0.771639 4.70308 1.05032 4.70308Z",
    fill: "#034A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05032 16.9062H20.1699C20.4486 16.9062 20.7159 16.7955 20.9129 16.5984C21.11 16.4014 21.2207 16.1341 21.2207 15.8554C21.2207 15.5768 21.11 15.3095 20.9129 15.1124C20.7159 14.9154 20.4486 14.8047 20.1699 14.8047H1.05032C0.771639 14.8047 0.504375 14.9154 0.30732 15.1124C0.110264 15.3095 -0.000442505 15.5768 -0.000442505 15.8554C-0.000442505 16.1341 0.110264 16.4014 0.30732 16.5984C0.504375 16.7955 0.771639 16.9062 1.05032 16.9062Z",
    fill: "#034A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05076 10.8046H24.9492C25.2279 10.8046 25.4952 10.6939 25.6922 10.4969C25.8893 10.2998 26 10.0326 26 9.75388C26 9.47521 25.8893 9.20794 25.6922 9.01089C25.4952 8.81383 25.2279 8.70312 24.9492 8.70312H1.05076C0.772081 8.70312 0.504816 8.81383 0.30776 9.01089C0.110704 9.20794 0 9.47521 0 9.75388C0 10.0326 0.110704 10.2998 0.30776 10.4969C0.504816 10.6939 0.772081 10.8046 1.05076 10.8046Z",
    fill: "#034A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05076 23.0078H24.9492C25.2279 23.0078 25.4952 22.8971 25.6922 22.7C25.8893 22.503 26 22.2357 26 21.957C26 21.6783 25.8893 21.4111 25.6922 21.214C25.4952 21.017 25.2279 20.9062 24.9492 20.9062H1.05076C0.772081 20.9062 0.504816 21.017 0.30776 21.214C0.110704 21.4111 0 21.6783 0 21.957C0 22.2357 0.110704 22.503 0.30776 22.7C0.504816 22.8971 0.772081 23.0078 1.05076 23.0078Z",
    fill: "#034A73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5464_4028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "matrix(-1 0 0 1 26 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoretext);
export default __webpack_public_path__ + "static/media/moretext.a715f3ce7c1f068174d901e97e1238f5.svg";
export { ForwardRef as ReactComponent };